export default "__VITE_ASSET__CBfl8KZj__"